// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"512":"6063e0e8","600":"df0d1d64","920":"ff5b76ee"}[chunkId] + ".chunk.js";
};